import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import ViewBase from '../../../views/view-base';
import { tIfExistsAndIsValid } from '../../../util/i18next-helpers';

function View(): JSX.Element {
  const { t } = useTranslation();

  const backgroundImageImageSrc = tIfExistsAndIsValid('claim.landing.background_image.src');

  return (
    <ViewBase
      localePrefix="claim"
      headerText={t('claim.landing.text')}
      prefix="claim-placeholder"
      backgroundImageSrc={backgroundImageImageSrc}
      backgroundImageAltText={t('claim.landing.background_image.alt')}
      footerText={t('claim.landing.footer')}
    />
  );
}

export default withTranslation()(View);
